<template>
  <b-card v-if="layout === 'b-card'">
    <slot />
  </b-card>
  <div v-else>
    <slot />
  </div>
</template>

<script>
export default {
  props: ['layout']
}
</script>
